export const STAGE2_PRINCIPLES_PUZZLE_POINTS = 100;

export const PRINCIPLE_WORDS = [
  "PRIORITIZE",
  "PLAN",
  "FOCUS",
  "REST",
  "BALANCE",
];

/** Click targets on the room illustration — positions are set in stage2Escape.css. */
export const PRINCIPLE_HOTSPOTS = [
  { id: "PRIORITIZE", label: "PRIORITIZE" },
  { id: "PLAN", label: "PLAN" },
  { id: "FOCUS", label: "FOCUS" },
  { id: "REST", label: "REST" },
  { id: "BALANCE", label: "BALANCE" },
];

export const STRESS_START = 48;
export const STRESS_AFTER_CALENDAR = 38;
export const STRESS_AFTER_CHANNEL = 28;
export const STRESS_BALANCED = 18;

export function stressAfterFinds(foundCount, stressStart = STRESS_AFTER_CHANNEL) {
  const total = PRINCIPLE_WORDS.length;
  if (foundCount >= total) return STRESS_BALANCED;
  const step = (stressStart - STRESS_BALANCED) / total;
  return Math.round(stressStart - step * foundCount);
}

/** Summary stats shown on the final completion screen. */
export const FINAL_GAME_STATS = {
  tasksPrioritized: 8,
  emailsManaged: 14,
  meetingsOptimized: 7,
  principlesFound: PRINCIPLE_WORDS.length,
};
